import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { environment } from '@shared/environments';

@Component({
  selector: 'shared-ui-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.css'],
  imports: [RouterLink],
})
export class LogoComponent {
  // TODO: Move this component away from ui or move AppRoutes to more general place
  //  in order to use it everywhere
  initialRoute = '/sites';
  protected readonly environment = environment;
}
